import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'tshirt',
  templateUrl: './tshirt.component.html',
  styleUrls: ['./tshirt.component.css']
})
export class TShirtComponent implements OnInit {

  showVideo = false;
  
  constructor() {
  }
  ngOnInit() {
   
  }
}

